// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const geodude_alola: PokeData = {
  "id": 10109,
  "name": "geodude-alola",
  "height": 4,
  "weight": 203,
  "base_experience": 60,
  "types": [
    PokeType.ROCK,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "tackle",
    "take-down",
    "double-edge",
    "thunder-shock",
    "rock-throw",
    "defense-curl",
    "bide",
    "self-destruct",
    "explosion",
    "rock-slide",
    "rollout",
    "spark",
    "charge",
    "rock-blast",
    "rock-polish",
    "discharge",
    "stone-edge",
    "stealth-rock",
    "smack-down"
  ],
  "moves": [
    "thunder-punch",
    "tackle",
    "thunder-shock",
    "rock-throw",
    "rock-slide",
    "rock-blast",
    "stealth-rock",
    "thunderbolt",
    "thunder",
    "ancient-power",
    "stone-axe",
    "seismic-toss",
    "zap-cannon"
  ],
  "evolution_chain": {
    "id": 31,
    "item": null,
    "species": [
      {
        "name": "geodude-alola",
        "order": 80,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "graveler-alola",
        "order": 81,
        "types": [
          PokeType.ROCK,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 74,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "golem-alola",
        "order": 82,
        "types": [
          PokeType.ROCK,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 75,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 40,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
